export * from "./lib/feature-maaler-aflaesning.module";
